import React, { useContext, useEffect } from 'react';
import { DataContext } from '../data/DataContext';
import { Input, DateControl, DropDown } from '../components'
import { catTypeDocument } from '../data/MochaData'

const StepSpouse = () => {
    const { AutoEmisionCR, setAutoEmisionCR, ChangeHandler } = useContext(DataContext);
    const onChange = (property: string, value: string) => setAutoEmisionCR({ ...AutoEmisionCR, [property]: value });
    const onChangeDate = (propierties: string, value: Date) => setAutoEmisionCR({ ...AutoEmisionCR, [propierties]: value })

    return <>
        <Input
            id='spouseName'
            field='spouseName'
            label='Nombre del cónyuge'
            value={AutoEmisionCR.spouseName}
            onChange={ChangeHandler}
        />
        <Input
            id='spouseLastName'
            field='spouseLastName'
            label='Apellidos del cónyuge'
            value={AutoEmisionCR.spouseLastName}
            onChange={ChangeHandler}
        />
        <Input
            id='spouseBirthPlace'
            field='spouseBirthPlace'
            label='Lugar de nacimiento'
            value={AutoEmisionCR.spouseBirthPlace}
            onChange={ChangeHandler}
        />
        <DateControl
            id='spouseBirthdate'
            label='Fecha de nacimiento'
            value={AutoEmisionCR.spouseBirthdate}
            onChange={onChangeDate}
        />
        <DropDown
            id='spouseCountryOrigin'
            dataProvider={AutoEmisionCR.catCountryOfOrigin}
            field='spouseCountryOrigin'
            label='País de origen'
            onChangeSelect={onChange}
            valueSelect={AutoEmisionCR.spouseCountryOrigin}
        />
        <DropDown
            id='spouseProfession'
            dataProvider={AutoEmisionCR.catProfesion}
            field='spouseProfession'
            label='Profesión'
            onChangeSelect={onChange}
            valueSelect={AutoEmisionCR.spouseProfession}
        />
        <DropDown
            id='spouseIdentificationType'
            dataProvider={catTypeDocument}
            field='spouseIdentificationType'
            label='Tipo de identificación'
            onChangeSelect={onChange}
            valueSelect={AutoEmisionCR.spouseIdentificationType}
        />
        {AutoEmisionCR.spouseIdentificationType === '1' &&
            <Input
                id='identification'
                label='Número de identificación'
                value={AutoEmisionCR.spouseIdentification}
                field='spouseIdentification'
                onChange={ChangeHandler}
                placeholder="Identificación"
                type='mask'
                mask="9-9999-9999"
                pattern="\d-\d\d\d\d-\d\d\d\d"
                title="Documento invalido"
            />
        }

        {AutoEmisionCR.spouseIdentificationType !== '1' &&
            < Input
                id='spouseIdentification'
                label='Número de identificación'
                value={AutoEmisionCR.spouseIdentification}
                field='spouseIdentification'
                onChange={ChangeHandler}
            />
        }
        <Input
            id='spousePhoneNumber'
            field='spousePhoneNumber'
            label='Número celular'
            value={AutoEmisionCR.spousePhoneNumber}
            onChange={ChangeHandler}
            placeholder='0000-0000'
            type='mask'
            mask="9999-9999"
            title="Documento invalido"
        />
    </>
}

export { StepSpouse }